import LinkedOptions from './LinkedOptions';
import themeUtils from '../themeUtils';

export default class VariantHelper {
  constructor(options) {
    const defaultOptions = {
      $addToCartButton: null, // Set with object of add to cart button
      $priceFields: null, // Set with object containing price(s)
      $productForm: null, // Set with object containing the `data-product-form` attribute
      $productThumbnails: null, // Set with object containing thumbnails
      $selector: null, // Set with an object that contains select/input[type=checkbox] objects
      type: 'select', // Or radio
      productJSON: null, // Set with product JSON information
      productSettings: null, // Set with JSON containing product message strings and/or display options,
      unitPrice: null, // Set with DOM node containing unit price
      taxLine: null, // DOM node containing 'tax included' text
    };

    this.options = themeUtils.extend(defaultOptions, options);

    this.$body = $(document.body);
    this.linkedOptions = null;
    this.enableHistory = false;
    this.$masterSelect = this.options.$productForm.find('.product-select');

    // Disabled history state updating in the TE
    const isShopify = window.Shopify && window.Shopify.preview_host;

    if (window.history
      && window.history.replaceState
      && this.options.productSettings.enableHistory
      && !isShopify) {
      this.enableHistory = true;
    }

    this._init();
    this._bindEvents();
  }

  _init() {
    if (this.options.type === 'select') {
      for (let i = 0; i < this.options.$selector.length; i++) {
        const select = this.options.$selector[i];
        this._setSelectLabel(null, $(select));
      }
    }

    if (this.options.productSettings.linkedOptions) {
      this.linkedOptions = new LinkedOptions(this.options);
    }
  }

  _bindEvents() {
    return this.options.$selector.on('change.variant-helper', event => this._variantChange(event));
  }

  unload() {
    return this.options.$selector.off('.variant-helper');
  }

  _setSelectLabel(event = null, $target) {
    if ($target == null) { $target = false; }
    if (!$target) {
      $target = $(event.currentTarget);
    }

    const selectedOption = $target.find('option:selected').val();
    return $target
      .prev('[data-select-text]')
      .find('[data-selected-option]')
      .text(selectedOption);
  }

  _getCurrentOptions() {
    const productOptions = [];
    let $inputs = this.options.$selector;

    if (this.options.type === 'radio') {
      $inputs = $inputs.filter(':checked');
    }

    $inputs.each((index, element) => productOptions.push($(element).val()));

    return productOptions;
  }

  _getVariantFromOptions(productOptions) {
    if (this.options.productJSON.variants == null) { return; }

    let foundVariant = null;

    for (let i = 0; i < this.options.productJSON.variants.length; i++) {
      const variant = this.options.productJSON.variants[i];

      const isMatch = productOptions.every((value, index) => variant.options[index] === value);

      if (isMatch) {
        foundVariant = variant;
      }
    }

    return foundVariant;
  }

  _updateMasterSelect(variant) {
    if (variant == null) { return; }

    __guard__(this.$masterSelect.find(`[data-variant-id=${variant.id}]`), x => x.prop('selected', true));

    return this.$masterSelect.trigger('change');
  }

  _updatePrice(variant) {
    const {
      $addToCartButton,
      $priceFields,
      productSettings,
      unitPrice,
      taxLine,
      productDetails
    } = this.options;

    const unitPriceAmount = unitPrice.querySelector('[data-unit-price-amount]');
    const unitPriceMeasure = unitPrice.querySelector('[data-unit-price-measure]');
    const unitPriceQuantity = unitPrice.querySelector('[data-unit-price-quantity]');

    if (variant) {
      // strip all of the old data attributes

      for (let i = 0; i < $priceFields.length; i++) {
        const priceField = $priceFields[i];
        const $moneyEl = $(priceField).find('.money');
        for (let j = 0; j < $moneyEl[0].attributes.length; j++) {
          const attribute = $moneyEl[0].attributes[j];
          if (attribute.name.indexOf('data-') > -1) {
            $moneyEl.removeAttr(attribute.name);
          }
        }
      }

      if (taxLine) {
        if (variant.taxable) {
          taxLine.classList.remove('hidden');
          productDetails.classList.add('has-tax-line');
        } else {
          taxLine.classList.add('hidden');
          productDetails.classList.remove('has-tax-line');
        }
      }

      if (variant.available) {
        $addToCartButton
          .val(productSettings.addToCartText)
          .removeClass('disabled')
          .removeAttr('disabled');
      } else {
        $addToCartButton
          .val(productSettings.soldOutText)
          .addClass('disabled')
          .attr('disabled', 'disabled');
      }

      if (variant.compare_at_price > variant.price) {
        $priceFields
          .find('.money:not(.original)')
          .html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        $priceFields
          .find('.original')
          .html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat))
          .addClass('visible');
      } else {
        $priceFields
          .find('.money')
          .html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        $priceFields
          .find('.original')
          .removeClass('visible');
      }

      if (variant.unit_price) {
        unitPrice.classList.remove('hidden');
        if (unitPriceQuantity) {
          unitPriceQuantity.innerHTML = `${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`;
        }

        if (unitPriceAmount) {
          unitPriceAmount.innerHTML = Shopify.formatMoney(variant.unit_price, Theme.moneyFormat);
        }

        if (unitPriceMeasure) {
          if (variant.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasure.innerHTML = `${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`;
          } else {
            unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
          }
        }
      } else {
        unitPrice.classList.add('hidden');
      }
    } else {
      // Variant doesn't exist
      $addToCartButton
        .val(productSettings.unavailableText)
        .addClass('disabled')
        .attr('disabled', 'disabled');
    }
  }


  _updateImages(variant) {
    const imageId = __guard__(variant != null ? variant.featured_image : undefined, x => x.id);
    const imagePosition = __guard__(variant != null ? variant.featured_image : undefined, x1 => x1.position) - 1;

    this.options.productGallery.selectMediaByVariant(variant);
  }

  _updateHistory(variant) {
    if (!this.enableHistory || (variant == null)) { return; }

    const re = new RegExp('([?|&]variant=)[0-9]+(&{0,1})');

    let { search } = window.location;

    if (search.match(re)) {
      search = search.replace(re, `$1${variant.id}$2`);
    } else if (search.indexOf('?') !== -1) {
      search += `&variant=${variant.id}`;
    } else {
      search += `?variant=${variant.id}`;
    }

    const newUrl = [
      window.location.protocol,
      '//',
      window.location.host,
      window.location.pathname,
      search,
    ];

    const variantUrl = newUrl.join('');
    window.history.replaceState({ path: variantUrl }, '', variantUrl);
  }

  _variantChange(event) {
    if (this.options.type === 'select') {
      this._setSelectLabel(event);
    }

    const productOptions = this._getCurrentOptions();
    const variant = this._getVariantFromOptions(productOptions);

    this._updateMasterSelect(variant);
    this._updatePrice(variant);
    this._updateImages(variant);
    return this._updateHistory(variant);
  }
}

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}
